import React from 'react'

const AddBill = () => {
  return (
    <div>AddBill</div>
  )
}

export default AddBill
